import { Component, Input } from '@angular/core';
import { AppClientConfiguration, TranslationService } from '@sdbn/common';
import { DocumentPreview, TransportDocumentType } from '../../../../../components/transport-details-legacy/model/document-preview';

@Component({
    selector: 'app-transport-document-item',
    templateUrl: './transport-document-item.component.html',
    styleUrls: ['./transport-document-item.component.scss'],
    standalone: false
})
export class TransportDocumentItemComponent {

  previewType = 'UNKNOWN';

  serverRoot = this.appClientConfiguration.serverURLRoot;

  previewMimeTypes = ['image/png', 'image/jpeg'];

  preview: DocumentPreview;
  @Input('preview') set setPreview(preview: DocumentPreview) {
    this.preview = preview;

    if (this.previewMimeTypes.indexOf(this.preview.mimeType) !== -1) {
      this.previewType = 'PICTURE';
    } else if (this.preview.mimeType === 'application/pdf') {
      this.previewType = 'PDF';
    }
  }

  documentType = TransportDocumentType;

  constructor(
    public translationService: TranslationService,
    private appClientConfiguration: AppClientConfiguration
  ) {
  }

}
